import React from "react";
import {Container} from "react-bootstrap";
import "./RebagCertified.scss";
import RetinaImage from "react-retina-image";
import config from "../../config";
import RebagCertifiedCarousel from "./components/RebagCertifiedCarousel";
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import LazyLoad from "react-lazyload";

class RebagCertified extends React.Component {
    render() {
        return (
            <Container className="rebag-certified">

                <LazyLoad height={"100%"} offset={50} once={true}>
                    <RebagCertifiedCarousel />
                </LazyLoad>
                <LazyLoad height={"100%"} offset={50} once={true}>
                    <div className="rebag-certified__the-vault">
                        <div className="rebag-certified__the-vault--subtitle">Learn from the experts by exploring</div>
                        <div className="rebag-certified__the-vault--title">The Vault</div>
                        <div className="rebag-certified__the-vault--text">Gain your own luxury knowledge from our content hub filled with educational resources on brand histories, pricing trends and more</div>
                        <div className="rebag-certified__the-vault--video">
                            <iframe src="https://www.youtube.com/embed/R4G4BUq1L2A"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen></iframe>
                        </div>
                        <div className="rebag-certified__the-vault--cta-container">
                            <a href={`${config.host_rebag_vault}`} target="_blank" className="rebag-certified__the-vault--cta rbg-btn-black btn btn-secondary">Access The Vault</a>
                            <a href="https://www.youtube.com/channel/UCFiccERQRCFKyz9iJAWHg_w" target="_blank" className="rebag-certified__the-vault--cta rbg-btn-black btn btn-secondary">View All Videos</a>
                        </div>
                    </div>
                </LazyLoad>
                <LazyLoad height={"100%"} offset={50} once={true}>
                    <div className="rebag-certified__press">
                        <div className="rebag-certified__press--title">Rebag in the press</div>
                        <div className="rebag-certified__press--container">
                            <a href="https://wwd.com/business-news/retail/charles-gorra-rebag-the-opportunity-in-luxury-resale-1203238521/" target="_blank" className="rebag-certified__press--item">
                                <RetinaImage
                                    alt="WWD"
                                    title="WWD"
                                    src={`${config.MEDIA_URL}/img/rebag-certified/press/wwd.png`}
                                />
                                <div className="rebag-certified__press--text">Founder & CEO Discusses<br />Opportunity In Luxury Resale</div>
                            </a>
                            <a href="https://www.nytimes.com/2019/10/24/style/rebag-clair-handbag-stock-market.html" target="_blank" className="rebag-certified__press--item">
                                <RetinaImage
                                    alt="New York Times"
                                    title="New York Times"
                                    src={`${config.MEDIA_URL}/img/rebag-certified/press/new-york-times.png`}
                                />
                                <div className="rebag-certified__press--text">You Too Can Play The<br />Handbag Stock Market</div>
                            </a>
                            <a href="https://www.fastcompany.com/90457916/style-most-innovative-companies-2020" target="_blank" className="rebag-certified__press--item">
                                <RetinaImage
                                    alt="Fast Company"
                                    title="Fast Company"
                                    src={`${config.MEDIA_URL}/img/rebag-certified/press/fast-company.png`}
                                />
                                <div className="rebag-certified__press--text">The 10 Most Innovative<br />Style Companies</div>
                            </a>
                            <a href="https://www.vogue.com/article/rebag-clair-universal-appraisal-index" target="_blank" className="rebag-certified__press--item">
                                <RetinaImage
                                    alt="Vogue"
                                    title="Vogue"
                                    src={`${config.MEDIA_URL}/img/rebag-certified/press/vogue.png`}
                                />
                                <div className="rebag-certified__press--text">With Clair By Rebag, Shoppers<br />Are The Real Beneficiaries</div>
                            </a>
                            <a href="https://www.harpersbazaar.com/fashion/trends/a4361/best-vintage-consignment-websites/#:~:text=Rebag%20gives%20sellers%20cash%20for,within%20one%20to%20two%20days." className="rebag-certified__press--item">
                                <RetinaImage
                                    alt="Harpers Bazaar"
                                    title="Harpers Bazaar"
                                    src={`${config.MEDIA_URL}/img/rebag-certified/press/harpers-bazaar.png`}
                                />
                                <div className="rebag-certified__press--text">Rebag gives Sellers Cash For<br />Designer Handbags, Right Up Front</div>
                            </a>
                            <a href="https://www.elle.com/fashion/a33447409/rebag-the-vault-designer-database/" target="_blank" className="rebag-certified__press--item">
                                <RetinaImage
                                    alt="Elle"
                                    title="Elle"
                                    src={`${config.MEDIA_URL}/img/rebag-certified/press/elle.png`}
                                />
                                <div className="rebag-certified__press--text">Rebag Will Make You An Expert<br />In Designer Handbags</div>
                            </a>
                        </div>
                    </div>
                </LazyLoad>
                <LazyLoad height={"100%"} offset={50} once={true}>
                    <div className="rebag-certified__stores">
                        <div className="rebag-certified__stores--title">Visit Us In Stores</div>
                        <div className="rebag-certified__stores--links">
                            <a href="https://shop.rebag.com/collections/all-bags?_=pf&pf_st_availability_hidden=true&pf_t_stores=bc-filter-Miami+-+Midtown" target="_blank" className="rebag-certified__stores--link">Miami</a>
                            <a href="https://shop.rebag.com/collections/all-bags?_=pf&pf_st_availability_hidden=true&pf_t_stores=bc-filter-NYC+-+Madison+Avenue" target="_blank" className="rebag-certified__stores--link">New York</a>
                            <a href="https://shop.rebag.com/collections/all-bags?_=pf&pf_st_availability_hidden=true&pf_t_stores=bc-filter-LA+-+Santa+Anita" target="_blank" className="rebag-certified__stores--link">Los Angeles</a>
                        </div>
                        <RetinaImage
                            alt="Stores"
                            title="Stores"
                            src={`${config.MEDIA_URL}/img/rebag-certified/stores.jpg`}
                            checkIfRetinaImgExists={false}
                        />
                        <a href="https://rebag.com/store/" target="_blank" rel="noopener noreferrer" className="rebag-certified__stores--cta rbg-btn-ghost btn btn-secondary">See All Stores</a>
                    </div>
                </LazyLoad>
                <LazyLoad height={"100%"} offset={50} once={true}>
                    <div className="rebag-certified__return">
                        <div className="rebag-certified__return--title">Still Not Convinced?</div>
                        <div className="rebag-certified__return--text">Return your purchase within 7 days of receipt if you're not satisfied</div>
                        <a href={`${config.host_rebag_shop}/collections/new-arrivals`} target="_blank" className="rebag-certified__return--cta rbg-btn-black btn btn-secondary">Shop New Arrivals</a>
                    </div>
                </LazyLoad>
            </Container>
        );
    }
}

const mapStateToProps = function (state) {
    const {mobile_big} = state.appReducer;
    return {mobile_big};
};

export default connect(mapStateToProps, null)(RebagCertified);

